<mat-sidenav-container class="sidenav-container">
  <mat-sidenav #drawer class="sidenav" id="sidenav" fixedInViewport
    [attr.role]="(isHandset$ | async) ? 'dialog' : 'navigation'" [mode]="'side'" [opened]="true">
    <mat-toolbar id="toolbar">Menu</mat-toolbar>
    <mat-nav-list>
      <a class="nav-link" mat-list-item routerLink="/">Home</a>
      <a class="nav-link" mat-list-item routerLink="/skills">Skills</a>
      <a class="nav-link" mat-list-item routerLink="/academics">Academics</a>
      <a class="nav-link" mat-list-item routerLink="/xperience">Xperience</a>
      <a class="nav-link" mat-list-item routerLink="/intrests">Intrests</a>
      <a class="nav-link" mat-list-item routerLink="/about">About</a>
      <a class="nav-link" mat-list-item routerLink="/contact">Contact</a>
      <!-- <a class="nav-link" mat-list-item routerLink="/help">Help</a> -->
    </mat-nav-list>
  </mat-sidenav>
  <mat-sidenav-content>
    <mat-toolbar color="primary">
      <button type="button" aria-label="Toggle sidenav" mat-icon-button (click)="drawer.toggle()"
        *ngIf="isHandset$ | async">
        <mat-icon aria-label="Side nav toggle icon">menu</mat-icon>
      </button>
      <span [@fadeInLeft]="fadeInLeft" (click)="drawer.toggle()" class="branding">&lt;/Naresh&gt;</span>
    </mat-toolbar>
    <!-- Add Content Here -->
    <ng-content></ng-content>
  </mat-sidenav-content>
</mat-sidenav-container>
